import styleService from './StyleService';

/**
 * Service to calculate proper dialog positions that appear below the toolbar
 */
class DialogPositionService {
  /**
   * Get the toolbar height in pixels
   * @returns {number} The toolbar height in pixels
   */
  static getToolbarHeight() {
    const { getStyleVar } = styleService;
    const toolbarHeight = getStyleVar('--toolbar-height');
    // Extract numeric value from CSS variable (e.g., "57px" -> 57)
    return parseInt(toolbarHeight) || 57;
  }

  /**
   * Calculate the top position for a dialog to appear below the toolbar
   * @param {number} offset - Additional offset from toolbar (default: 20px)
   * @returns {number} The calculated top position in pixels
   */
  static getDialogTopPosition(offset = 20) {
    return this.getToolbarHeight() + offset;
  }

  /**
   * Get a default top position for dialogs (toolbar height + 20px)
   * @returns {number} Default top position in pixels
   */
  static getDefaultTopPosition() {
    return this.getDialogTopPosition(20);
  }

  /**
   * Get a top position for dialogs with more spacing (toolbar height + 40px)
   * @returns {number} Top position with more spacing in pixels
   */
  static getSpacedTopPosition() {
    return this.getDialogTopPosition(40);
  }
}

export default DialogPositionService; 